<ng-content select="[pre-title]"></ng-content>

<ng-container *ngIf="title">
  <h2 class="w500 marBot20 tAlignLeft">{{ title }}</h2>
  <p class="w300 darkGreyT tAlignLeft" *ngIf="subtitle">{{ subtitle }}</p>
  <ng-content select="[post-title]"></ng-content>
</ng-container>

<ng-content></ng-content>
